<template>
  <zjf-header show-small-popover></zjf-header>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/publictop.vue